import {
  CLINICAL_DOCUMENT_TYPES_AND_CODES,
  COMPLIANCE_DOCUMENT_TYPES_AND_CODES,
  ORDERS_DOCUMENT_TYPES_AND_CODES
} from 'utils/staticLists/documentTypes'

export const dataFormatMappers = {
  equipment: (item) => ({ label: item.name, value: item.name, code: item.name }),
  diagnoses: (item) => ({
    label: `${item.icd10_code} - ${item.description}`,
    value: item.description,
    code: item.icd10_code
  }),
  organizations: (item) => ({
    label: item.orgName,
    value: item.orgName,
    code: item.orgName
  }),
  therapies: (item) => ({
    label: item.valueCoding.display,
    value: item.valueCoding.display,
    code: item.valueCoding.code
  })
}

export const EDIT_HOURS_PARTIALLY_APPROVED_QUESTIONNAIRE_TASK = 5

export const ASSESSMENT_QA_DUE_DATE_DURATION = 5

export enum RecapGoalStatus {
  COMPLETED = 'completed',
  COMPLETED_AND_ONGOING = 'completed-and-ongoing',
  IN_PROGRESS = 'in-progress',
  NOT_STARTED = 'not-started',
  CANCELLED = 'cancelled'
}

export const recapGoalStatusSelectOptions: { value: RecapGoalStatus; label: string }[] = [
  { label: 'Completed', value: RecapGoalStatus.COMPLETED },
  { label: 'Completed and ongoing', value: RecapGoalStatus.COMPLETED_AND_ONGOING },
  { label: 'In progress', value: RecapGoalStatus.IN_PROGRESS },
  { label: 'Not started', value: RecapGoalStatus.NOT_STARTED },
  { label: 'Cancelled', value: RecapGoalStatus.CANCELLED }
]

export const ALL_DOCUMENT_TYPES_AND_CODES = {
  ...CLINICAL_DOCUMENT_TYPES_AND_CODES,
  ...COMPLIANCE_DOCUMENT_TYPES_AND_CODES,
  ...ORDERS_DOCUMENT_TYPES_AND_CODES
}

export const NARRATIVE_BACKGROUND_STRING = `We will continue to collaborate with the physician's office on any changes to the current plan of care. Skilled nurse to evaluate patient and develop a plan of care to be signed by physician. Patient to receive up to 3 PRN visits and 1 RN visit for recertification assessment, review of all medications, and supervision of aide during 56-60 days of current certification period.`

// Standardized validation message for required fields
export const DEFAULT_REQUIRED_FIELD_MESSAGE = 'Please add a valid response'
export const SELECT_PLACEHOLDER = 'Type or select an option'

export enum AssessmentGenerationError {
  MISSING_CAREGIVER_ERROR = 'Unable to create appointments without a caregiver',
  MISSING_CAREGIVER_TIMEZONE_ERROR = 'Unable to create appointments without a caregiver timezone',
  MISSING_PAT_ERROR = 'Unable to create appointments without latest PAT',
  MISSING_SOC_DATE_ERROR = 'Unable to create appointments without a SOC date',
  MISSING_AUTHORIZATION_INFO_ERROR = 'Unable to determine the authorization information from assessment',
  MISSING_CERT_PERIOD_ERROR = 'Unable to create appointments without a certification period',
  NOT_ENOUGH_AVAILABILITY_ERROR = 'Not enough availability to schedule patient visit'
}

// Certification and Recertification Time Constants
export const CERTIFICATION_PERIOD_F2F_WINDOW_DAYS = 30
export const RECERTIFICATION_PERIOD_F2F_WINDOW_DAYS = 60
export const F2F_DATE_PICKER_BACKWARD_LIMIT_DAYS = 90
